import { jsxs, jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SelectSlot } from '../../../shared/components/slot/Slot.mjs';
import { optionTitle, optionTitleText } from '../../../shared/styles/option.vanilla.mjs';

const SingleSelectOptionTitle = forwardRef(
  ({ children, className: classNameFromProps, rightSlot, ...props }, forwardedRef) => {
    const className = classNames(optionTitle, classNameFromProps);
    return /* @__PURE__ */ jsxs(
      Primitive.div,
      {
        "data-scope": "single-select",
        "data-part": "option-title",
        className,
        ref: forwardedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              "data-scope": "single-select",
              "data-part": "option-title-text",
              className: optionTitleText,
              children
            }
          ),
          /* @__PURE__ */ jsx(SelectSlot, { children: rightSlot })
        ]
      }
    );
  }
);

export { SingleSelectOptionTitle as SelectOptionTitle };
//# sourceMappingURL=OptionTitle.mjs.map
